import { render, staticRenderFns } from "./FabricCreate.vue?vue&type=template&id=615fdbbf&scoped=true"
import script from "./FabricCreate.vue?vue&type=script&lang=js"
export * from "./FabricCreate.vue?vue&type=script&lang=js"
import style0 from "./FabricCreate.vue?vue&type=style&index=0&id=615fdbbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fdbbf",
  null
  
)

export default component.exports